import { getFirByModelId, getLogByModelId, getPDBByModelId } from '../../../api/ispyb'

import PropTypes from 'prop-types'
import React from 'react'
import { getFileName } from '../../../helpers/Saxs/SaxsGeneralHelper'
import map from 'lodash/mapKeys'

class SaxsAbInitioTable extends React.Component {
  render() {
    const getModels = () => {
      const result = []

      map(this.props.subtractions, (subtraction, index1) =>
        map(subtraction.abInitioModels, (abInitioModel, index2) => {
          if (abInitioModel.averagedModel !== null) {
            result.push(
              <AbInitioTableRow
                model={abInitioModel.averagedModel}
                firstRowText="Reference"
                subtractionId={subtraction.subtractionId}
                proposal={this.props.proposal}
                user={this.props.user}
                key={'averagedModel' + String(index1) + String(index2)}
              />
            )
          }

          if (abInitioModel.shapeDeterminationModel !== null) {
            result.push(
              <AbInitioTableRow
                model={abInitioModel.shapeDeterminationModel}
                firstRowText="Refined"
                subtractionId={subtraction.subtractionId}
                proposal={this.props.proposal}
                user={this.props.user}
                key={'shapeDeterminationModel' + String(index1) + String(index2)}
              />
            )
          }

          if (abInitioModel.modelList !== null) {
            if (abInitioModel.modelList.models !== null) {
              abInitioModel.modelList.models.forEach((model, index3) => {
                result.push(
                  <AbInitioTableRow
                    model={model}
                    firstRowText="Model"
                    subtractionId={subtraction.subtractionId}
                    proposal={this.props.proposal}
                    user={this.props.user}
                    key={String(index1) + String(index2) + String(index3)}
                  />
                )
              })
            }
          }
        })
      )
      return result
    }

    return (
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>Type</th>
            <th>chiSqrt</th>
            <th>rFactor</th>
            <th>Rg</th>
            <th>PDB</th>
            <th>Fir</th>
            <th>Log</th>
          </tr>
        </thead>
        <tbody>{getModels()}</tbody>
      </table>
    )
  }
}

export default SaxsAbInitioTable

SaxsAbInitioTable.propTypes = {
  /* proposal name */
  proposal: PropTypes.string,
  /* subtraction list */
  subtractions: PropTypes.array,
  /*  */
  user: PropTypes.string,
}

/* React compoent which render a row of the abinitio table */
const AbInitioTableRow = props => (
  <tr>
    <td> {props.firstRowText} </td>
    <td> {props.model.chiSqrt} </td>
    <td> {props.model.rfactor} </td>
    <td> {props.model.rg} </td>
    <td>
      <a
        href={getPDBByModelId(props.user, props.proposal, props.subtractionId, props.model.modelId)}
        target="_blank"
        rel="noreferrer"
      >
        {getFileName(props.model.pdbFile, false)}
      </a>
      {/* <a href='../viewer/uglymol/index.html?pdb={.pdbURL}' target='_blank'>
                <span class="glyphicon glyphicon-eye-open"></span>
            </a> */}
    </td>
    <td>
      <a
        href={getFirByModelId(props.user, props.proposal, props.subtractionId, props.model.modelId)}
        target="_blank"
        rel="noreferrer"
      >
        {getFileName(props.model.firFile, false)}
      </a>
    </td>
    <td>
      <a
        href={getLogByModelId(props.user, props.proposal, props.subtractionId, props.model.modelId)}
        target="_blank"
        rel="noreferrer"
      >
        {getFileName(props.model.logFile, false)}
      </a>
    </td>
  </tr>
)
